import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/home/index.vue';

Vue.use(Router);

export default new Router({
    routes: [
        // 首頁
        {
            path: '/',
            props: true,
            name: 'Home',
            component: Home,
        },
        {
            path: '/Magazine/:id',
            name: 'Magazine',
            component: Home,
        },
    ],
});
